import { SVGProps } from 'react';

export function Plant(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width={24}
      height={24}
      fill='none'
    >
      <rect
        width='24'
        height='24'
        rx='2'
        fill='#FFF2E8'
      />
      <path
        d='M12.3332 18.6666H6.7199C5.94657 18.6666 5.31323 18.0466 5.31323 17.2866V7.39324C5.31323 5.64657 6.61323 4.85324 8.20657 5.63324L11.1666 7.08657C11.8066 7.39991 12.3332 8.23324 12.3332 8.93991V18.6666Z'
        stroke='#FA541C'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.6466 14.0396V16.5596C18.6466 17.9996 17.9799 18.6663 16.5399 18.6663H12.3333V10.9463L12.6466 11.013L15.6466 11.6863L16.9999 11.9863C17.8799 12.1796 18.5999 12.633 18.6399 13.913C18.6466 13.953 18.6466 13.993 18.6466 14.0396Z'
        stroke='#FA541C'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.66675 10H9.98008'
        stroke='#FA541C'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.66675 12.667H9.98008'
        stroke='#FA541C'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.6467 11.687V13.8337C15.6467 14.6603 14.9734 15.3337 14.1467 15.3337C13.3201 15.3337 12.6467 14.6603 12.6467 13.8337V11.0137L15.6467 11.687Z'
        stroke='#FA541C'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.6401 13.9132C18.6001 14.6999 17.9467 15.3332 17.1467 15.3332C16.3201 15.3332 15.6467 14.6599 15.6467 13.8332V11.6865L17.0001 11.9865C17.8801 12.1799 18.6001 12.6332 18.6401 13.9132Z'
        stroke='#FA541C'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
